import React from 'react'
import routes from './routes'
import { createClient } from 'boiler-room-runner'
import ReactDOM from 'react-dom'
import { configureClientStore, fetchSiteContent } from './store'
import { updateEnvironment } from './lib/environment'
import { parseJSON } from './lib/json'
import createLocals from './lib/createLocals'
import a11y from 'react-a11y'
import sites from './lib/siteDomains'
import 'constructicon/lib/css/reset.css'

if (process.env.NODE_ENV !== 'production') {
  a11y(React, { ReactDOM })
}

const basepath = process.env.BASE_PATH
const initialState = parseJSON(document.getElementById('initial-state').innerHTML)
const store = configureClientStore(initialState)

const previewSettings = store.getState().prismic || {}
const uid = previewSettings.previewUID || process.env.DOCUMENT_UID || window.location.host
const repo = previewSettings.repo || process.env.PRISMIC_REPO || sites[uid]
const token = previewSettings.previewToken || null

store.dispatch(fetchSiteContent(repo, uid, token))
  .then(() => {
    const state = store.getState()
    const App = createClient({ basepath, routes, store, createLocals })

    if (state.site) {
      updateEnvironment(state.site.data.environment)
    }

    ReactDOM.render(<App />, document.getElementById('mount'))
  })
